import { 
    IconButton, 
    TableCell, 
    TableHead, 
    TableRow, 
    Table,
    Skeleton,
    Tooltip,
    TableBody,
    TableContainer,
    Paper
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ReactFade } from "./ReactFade";

interface MahjongSummaryTableProps {
    tableData: Array<{ type: string, accuracy: number, avgTime: number }>,
    small?: boolean,
    isLoadingUserBehavior: boolean
}
interface RowProps {
  data: { type: string, accuracy: number | undefined | null, avgTime: number | undefined | null, all_player_accuracy: number | undefined, all_player_avgTime: number | undefined },
}

function Row(props: RowProps) {
  const [open, setOpen] = useState<boolean>(false);
  const {t} = useTranslation();

  const handleRowOpen = () => {
    setOpen(!open);
  }

  return (
    <TableRow hover>
      {/* <TableCell style={{ width: 30 }} > */}
        {/* <IconButton size="small" onClick={() => handleRowOpen()}>
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton> */}
      {/* </TableCell> */}

      <TableCell style={{ width: "20%", textAlign: "center" }} >{props.data.type}</TableCell>

      <TableCell style={{ width: "20%", textAlign: "center", backgroundColor: "silver" }} >
        <ReactFade in={props.data.accuracy !== undefined}>
          <div>
            {(props.data.accuracy !== undefined && props.data.accuracy !== null && !isNaN(props.data.accuracy) ? Math.round(props.data.accuracy *10) / 10 + '%' : t("no__.data"))}
          </div>
        </ReactFade>
        <ReactFade in={props.data.accuracy === undefined}>
          <Skeleton width={65} />
        </ReactFade>
      </TableCell>

      <TableCell style={{ width: "20%", textAlign: "center" }} >
        <ReactFade in={props.data.all_player_accuracy !== undefined}>
          {(props.data.all_player_accuracy !== undefined && props.data.all_player_accuracy !== null && !isNaN(props.data.all_player_accuracy) ? Math.round(props.data.all_player_accuracy *10) /10 + '%' : t("no__.data"))}
        </ReactFade>
        <ReactFade in={props.data.all_player_accuracy === undefined}>
          <Skeleton width={65} />
        </ReactFade>
      </TableCell>

      <TableCell style={{ width: "20%", textAlign: "center", backgroundColor: "silver" }} >
        <ReactFade in={props.data.avgTime !== undefined}>
          {(props.data.avgTime !== undefined && props.data.avgTime !== null && !isNaN(props.data.avgTime) ? Math.round(props.data.avgTime *10) / 10 + " " + t("units_date.second") : t("no__.data"))}
        </ReactFade>
        <ReactFade in={props.data.avgTime === undefined}>
          <Skeleton width={65} />
        </ReactFade>
      </TableCell>

      <TableCell style={{ width: "20%", textAlign: "center" }} >
        <ReactFade in={props.data.all_player_avgTime !== undefined}>
          {(props.data.all_player_avgTime !== undefined && props.data.all_player_avgTime !== null && !isNaN(props.data.all_player_avgTime) ? Math.round(props.data.all_player_avgTime * 10) / 10 + " " + t("units_date.second") : t("no__.data"))}
        </ReactFade>
        <ReactFade in={props.data.all_player_avgTime === undefined}>
          <Skeleton width={65} />
        </ReactFade>
      </TableCell>
    </TableRow >
  )
}
  
export default function MahjongSummaryTable(props: MahjongSummaryTableProps) {
  const {t} = useTranslation();
  const dummyData = [
    {
      type: t("mahjong_key.draw"),
      accuracy: undefined,
      avgTime: undefined,
      all_player_accuracy: undefined,
      all_player_avgTime: undefined
    },
    {
      type: t("mahjong_key.discard"),
      accuracy: undefined,
      avgTime: undefined,
      all_player_accuracy: undefined,
      all_player_avgTime: undefined
    },
    {
      type: t("mahjong_key.chow"),
      accuracy: undefined,
      avgTime: undefined,
      all_player_accuracy: undefined,
      all_player_avgTime: undefined
    },
    {
      type: t("mahjong_key.pong"),
      accuracy: undefined,
      avgTime: undefined,
      all_player_accuracy: undefined,
      all_player_avgTime: undefined
    },
    {
      type: t("mahjong_key.gong"),
      accuracy: undefined,
      avgTime: undefined,
      all_player_accuracy: undefined,
      all_player_avgTime: undefined
    },
    {
      type: t("mahjong_key.dark_gong"),
      accuracy: undefined,
      avgTime: undefined,
      all_player_accuracy: undefined,
      all_player_avgTime: undefined
    },
    {
      type: t("mahjong_key.eat"),
      accuracy: undefined,
      avgTime: undefined,
      all_player_accuracy: undefined,
      all_player_avgTime: undefined
    },
    {
      type: t("mahjong_key.selfdraw"),
      accuracy: undefined,
      avgTime: undefined,
      all_player_accuracy: undefined,
      all_player_avgTime: undefined
    },
  ]

  return (
    <TableContainer component={Paper}>
      <Table size={props.small ? "small" : 'medium'}>
        <TableHead>
          <TableRow style={{ backgroundColor: '#f2f2f2' }}>
            {/* <TableCell style={{ width: "20%" }} /> */}
            <Tooltip title={t("mahjongSummaryTable.title_action")} style={{ textAlign: "center" }} arrow placement="top"><TableCell>{t("mahjongSummaryTable.text_action")}</TableCell></Tooltip>
            <Tooltip title={t("mahjongSummaryTable.title_wrong")} style={{ textAlign: "center" }} arrow placement="top"><TableCell>{t("mahjongSummaryTable.text_wrong")}</TableCell></Tooltip>
            <Tooltip title={t("mahjongSummaryTable.title_user_avg_wrong")} style={{ textAlign: "center" }} arrow placement="top"><TableCell>{t("mahjongSummaryTable.text_user_avg_wrong")}</TableCell></Tooltip>
            <Tooltip title={t("mahjongSummaryTable.title_avg_accuracy")} style={{ textAlign: "center" }} arrow placement="top"><TableCell>{t("mahjongSummaryTable.text_avg_accuracy")}</TableCell></Tooltip>
            <Tooltip title={t("mahjongSummaryTable.title_user_avg_accuracy")} style={{ textAlign: "center" }} arrow placement="top"><TableCell>{t("mahjongSummaryTable.text_user_avg_accuracy")}</TableCell></Tooltip>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            props.tableData ?
            props.tableData.map((x: any, index) => (<Row key={"mahjong-summary-table-data-" + index} data={x} />))
            :
            dummyData.map((x: any, index) => (<Row key={"mahjong-summary-table-" + index} data={x} />))
          }
        </TableBody>
      </ Table >
    </TableContainer>
      
  )
}